import { useContext, useEffect, useState } from 'react'
import PropertiesList from '../components/properties_list'
import PropertyFilter from '../components/property_filter'
import useParams from '../../../services/helpers/custom_hook/paramsUrl';
import NewestProperties from '../components/newest_properties';
import { Context } from '../../../services/context/context_api'
import environment from '../../../environment'
import Cookies from 'js-cookie';
import './properties_index.sass'

const size = 12

function ProjectList() {
  const [setParamsUrl, setFiltersFromUrl] = useParams();
  let initialQueryState = setFiltersFromUrl()
  let initialQueryStatefilter = setFiltersFromUrl()
  const { actions } = useContext(Context)
  delete initialQueryStatefilter.pageg;
  const [queryFilters, setQueryFilters] = useState(initialQueryStatefilter)
  const [counties, setCounties] = useState([])
  const [properties, setProperties] = useState({
    all: []
  })
  const [recentProperties, setRecentProperties] = useState([])
  const [page, setPage] = useState(initialQueryState.pageg ? initialQueryState.pageg : 1)
  const [countPage, setCountPage] = useState(0)
  const [propertiesError, setPropertiesError] = useState(undefined)
  const [countiesError, setCountiesError] = useState(undefined)
  const [recentPropertiesError, setRecentPropertiesError] = useState(undefined)

  const [gfilter, setgfilter] = useState(initialQueryState)

  const getProperties = async () => {
    actions.setIsFetching(true)

    const axios = require('axios');
    axios.get(`${environment.ENDPOINT_CAPIRENTBACKEND}/portal`, { params: {...queryFilters, condition: 'Venta', 'page[number]':page} })
      .then(function (response) {
        // handle success
        const data = response.data
        const meta = response.data.meta

        if (data.data.length) {
          setCountPage(Math.ceil(meta.stats.total.count / size))
          setProperties({ ...properties, all: data })
          setPropertiesError(undefined)
        } else {
          setPropertiesError('¡Oh vaya!  Aún no hay propiedades que coincidan con tu búsqueda.')
        }
      })
      .catch(function (error) {
        // handle error
        return setPropertiesError('Ups... Ha ocurrido un error en el listado de propiedades. Inténtalo nuevamente')
      })
      .then(function () {
        // always executed
        actions.setIsFetching(false)
      });
  }

  const getCounties = async () => {
    const axios = require('axios');
    axios.get(`${environment.ENDPOINT_CAPIRENTBACKEND}/comunas`)
      .then(function (response) {
        // handle success
        const data = response.data
        setCounties(data)
        setCountiesError(undefined)
      })
      .catch(function (error) {
        // handle error
        setCountiesError('Ups... Ha ocurrido un error en el filtro de comunas')
      })
      .then(function () {
        // always executed
      });
  }

  const getRecentProperties = async () => {
    const axios = require('axios');
    axios.get(`${environment.ENDPOINT_CAPIRENTBACKEND}/portal`, { params: {condition: 'Venta', 'ordering': '-asset_publication__publication_id', 'page_size': 10} })
      .then(function (response) {
        // handle success
        const data = response.data
        setRecentProperties(data)
        setRecentPropertiesError(undefined)
      })
      .catch(function (error) {
        // handle error
        setRecentPropertiesError('Ups... Ha ocurrido un error en el listado de propiedades')
      })
      .then(function () {
        // always executed
      });
  }

  const setCampaign = async () => {
    let utm = {
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
    }

    let queryparams = window.location.search
    const re = /&amp;/gi;
    queryparams = queryparams.replace(re, "&");

    const params = new URLSearchParams(queryparams);

    let setCookieCampaign = false;
    if (params.get('utm_source')) {
      utm.utm_source = params.get('utm_source');
      setCookieCampaign = true;
    }
    if (params.get('utm_medium')) {
      utm.utm_medium = params.get('utm_medium');
      setCookieCampaign = true;
    }
    if (params.get('utm_campaign')) {
      utm.utm_campaign = params.get('utm_campaign');
      setCookieCampaign = true;
    }
    if (setCookieCampaign) {
      Cookies.set('utm', JSON.stringify(utm));
    }
  }

  const countyTitle = () => {
    const county = counties.data?.find(county => county.id == queryFilters?.conmune)
    return county ? county.name : 'todas las comunas'
  }

  useEffect(() => {
    getCounties();
    getRecentProperties();
    // eslint-disable-next-line
    setCampaign();
  }, [])

  useEffect(() => {
    getProperties()
    // eslint-disable-next-line
  }, [queryFilters, page])

  return (
    <div className='container'>
      <div className='px-md-0 px-3 properties-search-title-wrapper'>
        <h1 className='d-flex' style={{gap: '12px' }}>
          <img src="https://cdn.homierent.com/strapi-media/house_icon_1179bbfb16.svg" />
           Propiedades en venta {countyTitle()}
        </h1>
      </div>

      <div className="row root">
        <div className="col-lg-8 col-md-8 col-sm-12 col-12">
          <div className='d-mobile mb-4'>
            <PropertyFilter queryFilters={queryFilters} setgfilter={setgfilter} countiesError={countiesError} counties={counties} setQueryFilters={setQueryFilters} setPage={setPage} />
          </div>
          <PropertiesList gfilter={gfilter} setgfilter={setgfilter} propertiesError={propertiesError} properties={properties} countPage={countPage} queryFilters={queryFilters} counties={counties} page={page} setPage={setPage} />
        </div>   
        <div className="col-lg-4 col-md-4 col-sm-12 col-12">
          <div className='d-desktop'>
            <PropertyFilter queryFilters={queryFilters} setgfilter={setgfilter} countiesError={countiesError} counties={counties} setQueryFilters={setQueryFilters} setPage={setPage} />
          </div>
          <NewestProperties recentPropertiesError={recentPropertiesError} recentProperties={recentProperties} />
        </div>
      </div>
    </div>
  )
}

export default ProjectList
